/**
 * Scope for the Hooks inventory tab (KIR-3643). The same tab renders in the
 * organization view (scoped to an org) and in the personal dashboard (the
 * caller's own org-less hooks, via the `/account/hooks` routes).
 */
export type HookTabScope =
  | { kind: 'organization'; organizationId: string }
  | { kind: 'account' };

/**
 * Stable query-key discriminator for a scope, used only as a cache key (never to
 * reconstruct the scope). Namespaced (`org:<id>` vs `account`) so an org whose id
 * were literally `"account"` can't collide with the personal cache. (KIR-3643)
 */
export function hookScopeKey(scope: HookTabScope): string {
  return scope.kind === 'organization'
    ? `org:${scope.organizationId}`
    : 'account';
}
